// src/components/approval/ApprovalAction_CM.jsx
import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import PeopleCellLoader from "../common/people/PeopleCellLoader";
import { viewApprovalLine, addApprovalLine } from "../../api/approval";
import { updateDocStatus } from "../../api/papers";
import { getSafetyDocDetail, saveSafetyDoc } from "../../api/safety";
import PhotoBoardSelect from "../const/Photo/PhotoBoardSelect";

export default function ApprovalAction_CM({ dns, order }) {
    const me = JSON.parse(localStorage.getItem("user") || "{}");
    const myId = Number(me.id);
    const projectId = localStorage.getItem("projectId");

    const [line, setLine] = useState(null);
    const [cmComment, setCmComment] = useState("");
    const [decision, setDecision] = useState("");
    const [nextAssignee, setNextAssignee] = useState([]);
    const [photoboard, setPhotoboard] = useState(null);

    const [openPhotoModal, setOpenPhotoModal] = useState(false);



    /* =========================
       해당 차수 결재선 로드
    ========================= */
    useEffect(() => {
        const load = async () => {
            const res = await viewApprovalLine(dns);
            const approvalLines = res.data?.approval_lines || [];

            const target = approvalLines.find(
                (l) => Number(l.order) === Number(order)
            );

            setLine(target || null);

            console.log(res)
            setCmComment(target?.comment || "");
            setDecision("");
        };

        load();
    }, [dns, order]);

    // 결재선이 아직 없으면 (결재 요청 전) 표시 안 함
    if (!line) return null;

    /* =========================
       권한 판단
    ========================= */
    const isMyTurn =
        Number(line.approver_id) === myId &&
        line.is_approved === "submit";

    const statusLabel =
        line.is_approved === "approved"
            ? "승인"
            : line.is_approved === "rejected"
                ? "반려"
                : "결재 대기";

    /* =========================
       저장 (승인 / 반려)
    ========================= */
    const handleSave = async () => {
        if (!isMyTurn) return;

        if (decision === "rejected" && !cmComment.trim()) {
            alert("반려 시 확인 의견은 필수입니다.");
            return;
        }

        try {
            const currentOrder = Number(line.order);


            // 1️⃣ 현재 결재 처리
            await axios.patch(`approval/action/${line.id}/`, {
                action: decision,
                comment: cmComment,
            });

            // ❌ 반려면 즉시 문서 반려
            if (decision === "rejected") {
                await updateDocStatus(dns, "rejected");
                window.location.reload();
                return;
            }

            // ✅ 승인인 경우: 다음 결재자 처리
            const next = nextAssignee[0];
            const nextApproverId = next?.user?.id || next?.id;

            console.log("nextAssignee", nextAssignee);
            console.log("nextApproverId", nextApproverId);


            // ✅ 다음 결재자가 없으면 → 종결 여부 확인
            if (!nextApproverId) {
                const confirmClose = window.confirm(
                    "다음 결재자가 지정되지 않았습니다.\n문서를 종결하시겠습니까?"
                );

                if (!confirmClose) {
                    alert("다음 담당자를 지정해주세요.");
                    return; // ❗ 여기서 반드시 return
                }

                // 🔚 최종 승인
                const latest = await getSafetyDocDetail(dns);
                const latestMeta = latest.meta || {};

                await saveSafetyDoc({
                    dns,
                    project: latest.project,
                    title: latest.title,
                    doc_type: latest.doc_type,
                    status: "approved",
                    meta: {
                        ...latestMeta,
                        approval_photoboards: {
                            ...(latestMeta.approval_photoboards || {}),
                            [currentOrder]: photoboard || null, // ⭐ 여기
                        },
                    },
                });


                window.location.reload();
                return;
            }

            console.log(dns, nextApproverId, currentOrder + 1, "###")

            // ✅ 다음 결재선 추가 (하드코딩 제거)
            await addApprovalLine(
                {
                    doc_dns: dns,
                    approver_id: nextApproverId,
                    order: currentOrder + 1,
                },
                projectId
            );

            // 🔄 다음 결재 대기 상태
            await updateDocStatus(dns, "in_progress");
            window.location.reload();

        } catch (err) {
            console.error(err);
            alert("결재 처리 중 오류가 발생했습니다.");
        }
    };


    /* =========================
       UI
    ========================= */
    return (
        <div className=" text-sm">


            {/* ===== 내 차례 ===== */}
            {isMyTurn ? (
                <>
                    <textarea
                        className="w-full border rounded p-2 text-sm"
                        value={cmComment}
                        onChange={(e) => setCmComment(e.target.value)}
                        placeholder="확인 의견을 입력하세요"
                    />
                    <PhotoBoardSelect
                        isOpen={openPhotoModal}
                        onClose={() => setOpenPhotoModal(false)}
                        onSelect={(board) => {
                            setPhotoboard(board.id);   // ⭐ form 말고 local state
                            setOpenPhotoModal(false);
                        }}
                    />


                    <div className="mt-2 flex items-center gap-4">
                        <label className="flex items-center gap-1">
                            <input
                                type="radio"
                                value="approved"
                                checked={decision === "approved"}
                                onChange={(e) => setDecision(e.target.value)}
                            />
                            승인
                        </label>

                        <label className="flex items-center gap-1">
                            <input
                                type="radio"
                                value="rejected"
                                checked={decision === "rejected"}
                                onChange={(e) => setDecision(e.target.value)}
                            />
                            반려
                        </label>

                        <button
                            className="btn-save-sm"
                            disabled={!decision}
                            onClick={handleSave}
                        >
                            저장
                        </button>
                    </div>

                    {decision === "approved" && (
                        <div className="mt-2">
                            <label className="text-sm block mb-1">
                                다음 담당자 지정 (발주처)
                            </label>
                            <PeopleCellLoader
                                value={nextAssignee}
                                onChange={setNextAssignee}
                                single
                            />
                        </div>
                    )}
                </>
            ) : (
                /* ===== VIEW 모드 ===== */
                <div className="whitespace-pre-wrap text-xs">
                    {cmComment || "-"}
                </div>
            )}
        </div>
    );
}
